const goToDiPath = (path: string): void => {
  window.location.assign(`${process.env.REACT_APP_PG_MONOLITH_HOST}/disability-insurance/${path}`);
};

export default goToDiPath;
